/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import '../../components/Navigation/GenAINavigationMenu.css'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function GenAIGlobalMyProfile(props) {
    const { customWidth } = props
    const [compWidth, setWidth] = useState(0);
    const [display, setDisplay] = useState(false);
    const history = useHistory()
    const isRussian = JSON.parse(localStorage.getItem('russianuser'));
    const username = JSON.parse(localStorage.getItem('userdisplayName'));
    var width;

    useEffect(() => {
        if (document.getElementById('username-wrapper')) {
            width = document.getElementById('username-wrapper').offsetWidth;
            setWidth(width)
        }
    });

    const myProfilePopup = () => {
        setDisplay(!display)
    }

    if (window.location.pathname !== "/results" && window.location.pathname !== "/pubMedResults") {
        window.supportingDocsSearchStrategyDescription = undefined;
        window.isSupportingDocs = undefined;
    }

    if (customWidth < 600) {
        return (
            <div className="navigation-menu-wrapper-mobile">
            </div>
        )
    }
    else if (customWidth >= 600 && customWidth < 1000) {
        return (
            <div>
                <div className="genAIRecommended-header-left">
                    <div className="genAIRecommended-main-icons-titles-wrapper">
                        <div className="genAIRecommended-main-header-myProfile-icons" onClick={myProfilePopup}>
                            <div className="genAIRecommended-main-circle-container" style={{ background: display ? '#7d7a7a' : '#eb1600', boxShadow: display ? 'grey' : '' }}>
                                <p className="genAIRecommended-main-circle-text">{username.charAt(0)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {display &&
                    <ul className="genAIRecommended-main-navigation-sub-menu-wrapper" >
                        <li onClick={(e) => { history.push('/recommended') }}>Home</li>
                        <li onClick={(e) => {
                            if (isRussian) {
                                window.location.href = `${window.location.origin}/register-role`;
                            }
                            else {
                                window.location.href = `${window.location.origin}/registration`;
                            }
                            setDisplay(false)
                        }}>View/Edit Preferences</li>
                        <li onClick={(e) => { setDisplay(false); window.open("/ManageAlerts") }}>Alerts</li>
                        <li onClick={(e) => { window.open('/Get-Help') }}>Access Training Materials</li>
                        <li onClick={(e) => { window.open('/Contact-Us') }}>Contact Us</li>
                    </ul>
                }
            </div>
        )
    }
    else {
        return (
            <div className="genAIRecommended-main-div-header-left">
               <div className="genAIRecommended-header-left">
                    <div className="genAIRecommended-main-icons-container-mylink-myprofile">
                        <div className="genAIRecommended-main-header-myProfile-icons" onClick={myProfilePopup}>
                            <div className="genAIRecommended-main-circle-container" style={{ background: display ? '#7d7a7a' : '#eb1600', boxShadow: display ? 'grey' : '' }}>
                                <p className="genAIRecommended-main-circle-text">{username.charAt(0)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {display &&
                    <ul className="genAIRecommended-main-navigation-sub-menu-wrapper" >
                        <li onClick={(e) => { history.push('/recommended') }}>Home</li>
                        <li onClick={(e) => {
                            if (isRussian) {
                                window.location.href = `${window.location.origin}/register-role`;
                            }
                            else {
                                window.location.href = `${window.location.origin}/registration`;
                            }
                            setDisplay(false)
                        }}>View/Edit Preferences</li>
                        <li onClick={(e) => { setDisplay(false); window.open("/ManageAlerts") }}>Alerts</li>
                        <li onClick={(e) => { window.open('/Get-Help') }}>Access Training Materials</li>
                        <li onClick={(e) => { window.open('/Contact-Us') }}>Contact Us</li>
                    </ul>
                }
            </div>
        )
    }
}